import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import VisualizerBackground from '../components/VisualizerBackground';
import Metadata from '../components/Metadata';
import TestimonialAdmin from '../components/TestimonialAdmin';

const Admin = () => {
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    // Debug: Check if environment variable is loaded
    console.log('Admin password env:', process.env.REACT_APP_ADMIN_PASSWORD);
    console.log('Is authenticated:', sessionStorage.getItem('adminAuthenticated'));
  }, []);

  // Simple password protection - in production, you should use proper authentication
  const handleLogin = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const formData = new FormData(e.currentTarget);
    const password = formData.get('password') as string;
    
    // Debug: Log the password attempt
    console.log('Password attempt:', password);
    console.log('Expected password:', process.env.REACT_APP_ADMIN_PASSWORD);
    console.log('Password match:', password === process.env.REACT_APP_ADMIN_PASSWORD);
    
    // This is a simple example - in production, use proper authentication
    if (password === process.env.REACT_APP_ADMIN_PASSWORD) {
      console.log('Password correct, setting authentication...');
      sessionStorage.setItem('adminAuthenticated', 'true');
      navigate('/admin/dashboard');
    } else {
      console.log('Password incorrect');
      setError('Invalid password');
    }
  };

  // Check if user is authenticated
  const isAuthenticated = sessionStorage.getItem('adminAuthenticated') === 'true';
  console.log('Current authentication state:', isAuthenticated);

  // Render login form if not authenticated
  if (!isAuthenticated) {
    // Determine if we have an error for accessibility attributes
    const hasError = error !== null;

    return (
      <div className="min-h-screen bg-drummer-dark text-white flex items-center justify-center">
        <VisualizerBackground />
        <div className="glassmorphic p-8 rounded-lg max-w-md w-full">
          <h2 className="text-2xl font-bold mb-6 text-center">Admin Login</h2>
          <form onSubmit={handleLogin} className="space-y-4" autoComplete="off">
            <div>
              <label htmlFor="admin-password" className="block text-sm font-medium mb-1">
                Password
              </label>
              {hasError ? (
                <input
                  type="password"
                  id="admin-password"
                  name="password"
                  autoComplete="current-password"
                  required
                  aria-required="true"
                  aria-invalid="true"
                  aria-describedby="password-error"
                  className="w-full px-4 py-2 rounded-md bg-client-black/30 border border-client-gray/20 focus:border-client-yellow focus:ring-1 focus:ring-client-yellow focus:outline-none text-white"
                />
              ) : (
                <input
                  type="password"
                  id="admin-password"
                  name="password"
                  autoComplete="current-password"
                  required
                  aria-required="true"
                  aria-invalid="false"
                  className="w-full px-4 py-2 rounded-md bg-client-black/30 border border-client-gray/20 focus:border-client-yellow focus:ring-1 focus:ring-client-yellow focus:outline-none text-white"
                />
              )}
            </div>
            {error && (
              <div id="password-error" className="text-red-500 text-sm text-center" role="alert">
                {error}
              </div>
            )}
            <button
              type="submit"
              className="drum-button w-full"
              aria-label="Submit login form"
            >
              Login
            </button>
          </form>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-drummer-dark text-white">
      <Metadata 
        title="Admin Dashboard | Daryian Kelton"
        description="Admin dashboard for managing testimonials"
        pageType="home"
      />
      <VisualizerBackground />
      
      <div className="container mx-auto px-4 py-8">
        <div className="flex justify-between items-center mb-8">
          <h1 className="text-3xl font-bold">Admin Dashboard</h1>
          <button
            onClick={() => {
              sessionStorage.removeItem('adminAuthenticated');
              navigate('/admin');
            }}
            className="drum-button-outline"
            aria-label="Logout from admin dashboard"
          >
            Logout
          </button>
        </div>
        
        <TestimonialAdmin />
      </div>
    </div>
  );
};

export default Admin; 